export default __webpack_public_path__ + "static/media/proximitySound.35188309.mp3";